import React, { createContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isAuthenticated } from "../utils/auth";

export const AuthContext = createContext();

function AuthProvider({ children }) {

  const username = JSON.parse(localStorage.getItem("user"))?.username || "";
  const email = JSON.parse(localStorage.getItem("user"))?.email || "";
  const usernameLetter = username[0] || "G";
  const profileImageUrl =`https://place-hold.it/100x100/ee2244/FFFFFF?text=${usernameLetter}&fontsize=40&bold`;

  const history = useHistory();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPremium, setIsPremium] = useState(false);
  const [profileImage, setProfileImage] = useState(JSON.parse(localStorage.getItem("user"))?.profileImage || profileImageUrl);
  const [token, setToken] = useState(null);

  const checkAuth = async () => {
    const { valid, premium } = await isAuthenticated();
    setIsLoggedIn(valid);
    setIsPremium(premium);
    setProfileImage(JSON.parse(localStorage.getItem("user"))?.profileImage || profileImageUrl);

    if (!valid) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    } else {
      setToken(localStorage.getItem(("token")));
    }
  };
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setProfileImage(null);
    setIsLoggedIn(false);
    history.push("/");
  };

  const handleSetProfileImage = (profileImage) => {
    setProfileImage(profileImage);
    const user = JSON.parse(localStorage.getItem("user")) || {};
    user.profileImage = profileImage;
    localStorage.setItem("user", JSON.stringify(user));
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const props = {
    isLoggedIn,
    handleLogout,
    username,
    email,
    profileImage,
    handleSetProfileImage,
    verifyToken: token,
    isPremium,
    checkAuth
  };

  return (
    <AuthContext.Provider value={{ ...props }}>
      {children}
    </AuthContext.Provider>
  );
}
export default AuthProvider;

